<template>
  <div class="investBtns">
    <!-- <div class="btnsAction"></div> -->
    <v-btn v-if="currentTab===0" outlined color="primary" @click="onClick('clearInvestment')">Clear Investment</v-btn>
    <v-spacer></v-spacer>
    <div class="btnsNav">
      <v-btn v-if="currentTab" outlined color="primary" class="ml-4" @click="onClick('cancel')"
        >Cancel</v-btn
      >
      <v-btn v-if="currentTab === 0" class="ml-4" depressed color="primary" @click="onClick('next')"
        >Next</v-btn
      >
      <v-btn
        v-if="currentTab === 1"
        depressed
        color="primary"
        class="ml-4"
        @click="onClick('runInvest')"
        >Run Investment</v-btn
      >
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'InvestBtns',
  props: { currentTab: Number, reportList: Array },

  methods: {
    onClick(value) {
      if (value === 'next') this.$emit('next');
      if (value === 'cancel') this.$emit('cancel');
      if (value === 'runInvest') this.$emit('runInvest');
      if (value === 'clearInvestment') this.$emit('clearInvestment');
    },
  },
};
</script>

<style>
.investBtns {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
